module.exports = __webpack_public_path__ + "d86678285f665d81352bef11b7230ecc.svg";